import Collapsible from '../Collapsible';
import { DETAIL_TITLE } from 'constants/courseDescription';

const CollapsibleSection = (props) => {
  const {
    courseOrganizer,
    purchaseOption,
    coursOutlineFileName,
    courseOutline,
    expectedOutcomes,
    courseAudience,
    isBundling,
    courseInclusion,
    openedCollapsibles = [],
    prerequisite,
    handleCollaps,
    language,
  } = props;

  const collapsibleData = [
    {
      validation: courseInclusion !== ' ',
      title: `${isBundling ? '' : 'Course '}Features`,
      description: courseInclusion,
      isOpen: openedCollapsibles.includes(`${isBundling ? '' : 'Course '}Features`),
    },
    {
      validation: prerequisite !== '',
      title: `Prerequisites`,
      description: prerequisite,
      isOpen: openedCollapsibles.includes('Prerequisites'),
    },
    {
      validation: courseAudience !== '',
      title: `${isBundling ? '' : 'Course '}Audience`,
      description: courseAudience,
      isOpen: openedCollapsibles.includes(`${isBundling ? '' : 'Course '}Audience`),
    },
    {
      validation: expectedOutcomes !== '',
      title: `${isBundling ? '' : 'Course '}Outcomes`,
      description: expectedOutcomes,
      isOpen: openedCollapsibles.includes(`${isBundling ? '' : 'Course '}Outcomes`),
    },
    {
      validation: courseOutline.value !== '' && courseOutline.value !== ' ',
      title: `${isBundling ? '' : 'Course '}Outline`,
      description:
        courseOutline.outline == 'f'
          ? coursOutlineFileName +
            '&emsp;' +
            '&emsp;' +
            '&emsp;' +
            '&emsp;' +
            '&emsp;' +
            `&emsp; <a className="collapsible__download" href=${courseOutline.value} target="_blank" rel="noreferrer">Downloads</a>`
          : coursOutlineFileName,
      isOpen: openedCollapsibles.includes(`${isBundling ? '' : 'Course '}Outline`),
    },
    {
      validation: purchaseOption && purchaseOption !== '',
      title: DETAIL_TITLE.OTHER_RELATED_COURSES,
      description: purchaseOption,
      isOpen: openedCollapsibles.includes(DETAIL_TITLE.OTHER_RELATED_COURSES),
    },
    {
      validation: courseOrganizer && courseOrganizer.information && courseOrganizer?.information !== 'null',
      title: `${isBundling ? '' : 'Course '}Provider Information`,
      description: courseOrganizer?.information,
      isOpen: openedCollapsibles.includes(`${isBundling ? '' : 'Course '}Provider Information`),
    },
  ];

  return collapsibleData.map((item) => {
    return item.validation ? (
      <Collapsible
        title={item.title}
        description={item.description}
        isOpen={item.isOpen}
        changeModal={handleCollaps}
        key={item.title}
        language={language}
      />
    ) : null;
  });
};

export default CollapsibleSection;
